/**
 * 참고 : https://github.kakaocorp.com/kakaopage/karina/blob/fae72a2d83a63152e5f1cea68ecba7c8eaabbfa5/modules/karina-core/src/main/kotlin/com/kakaopage/karina/model/enums/ScreenType.kt#L15-L15
 */
export enum StaticLandingTypeVo {
  TodayNew = 'TODAY_NEW',
  TodayUp = 'TODAY_UP',
  TodayUpInven = 'TODAY_UP_INVEN',
  Original = 'ORIGINAL',
  Event = 'EVENT',
  Ranking = 'RANKING',
  RankingTheme = 'RANKING_THEME',
  DayOfWeek = 'DAY_OF_WEEK',
  FreeSeries = 'FREE_SERIES',
  Genre = 'GENRE',
  // Channel = 'CHANNEL',  // deprecated
}
